import React from 'react';

interface TimerProps {
  totalMs: number;
  remainingMs: number;
}

export default function Timer({ totalMs, remainingMs }: TimerProps) {
  const pct = totalMs > 0 ? (remainingMs / totalMs) * 100 : 0;
  const seconds = Math.ceil(remainingMs / 1000);

  let color = 'var(--success)';
  if (pct < 33) color = 'var(--danger)';
  else if (pct < 66) color = 'var(--warning)';

  return (
    <div className="timer">
      <div className="timer-bar-wrap">
        <div className="timer-bar" style={{ width: `${pct}%`, background: color }} />
      </div>
      <span className="timer-seconds" style={{ color }}>{seconds}s</span>
    </div>
  );
}
